import { ElementType } from 'react';
import { GridProps as MuiGridProps } from '@mui/material/Grid';
import { Grid } from '@mui/material';

// Define a custom type that extends the Material UI Grid props
export interface GridProps extends MuiGridProps {
  item?: boolean;
  container?: boolean;
  xs?: number | boolean;
  sm?: number | boolean;
  md?: number | boolean;
  lg?: number | boolean;
  xl?: number | boolean;
  component?: ElementType;
}

// Use a type assertion to work around TypeScript issues with Material UI Grid
export const GridItem = Grid as React.ComponentType<GridProps>;
